/*
 * <similar-products> — loads related-product recommendations (manual or automatic,
 * via the Product Recommendations API) into the sold-out "Benzer Ürünler" block,
 * and keeps it in sync with the theme's existing variant-change pub/sub.
 * No external libraries. Runs only where the block is rendered (product pages).
 */
(function () {
  if (customElements.get('similar-products')) return;

  customElements.define(
    'similar-products',
    class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.getAttribute('data-section-id');
        this.loadRecommendations();

        if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
          this.unsubscribe = subscribe(
            window.theme.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
      }

      onVariantChange(event) {
        try {
          if (!event || !event.data || String(event.data.sectionId) !== String(this.sectionId)) return;
          // Replace our content with the freshly rendered section for the new variant,
          // then (re)load recommendations if the block is now shown (sold out).
          var fresh =
            event.data.html &&
            (event.data.html.querySelector('similar-products[data-section-id="' + this.sectionId + '"]') ||
              event.data.html.querySelector('similar-products'));
          this.innerHTML = fresh ? fresh.innerHTML : '';
          this.loadRecommendations();
        } catch (error) {
          /* no-op: never break the product page */
        }
      }

      loadRecommendations() {
        var root = this.querySelector('[data-oh-similar-root]');
        if (!root) return;

        var url = root.getAttribute('data-oh-similar-recs-url');
        var track = root.querySelector('[data-oh-similar-track]');
        if (!url || !track) return;
        if (root.getAttribute('data-loaded') === '1') return;
        root.setAttribute('data-loaded', '1');

        fetch(url)
          .then(function (response) {
            if (!response.ok) throw response.status;
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var recs = doc.querySelector('[data-oh-similar-recs]');
            var items = recs ? recs.innerHTML.trim() : '';
            if (items) {
              track.innerHTML = items;
              root.removeAttribute('hidden');
            }
          })
          .catch(function () {
            /* recommendations unavailable — leave the block hidden */
          });
      }
    }
  );
})();
